"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandyBlastRequestBodyToJSON = exports.CandyBlastRequestBodyFromJSONTyped = exports.CandyBlastRequestBodyFromJSON = void 0;
function CandyBlastRequestBodyFromJSON(json) {
    return CandyBlastRequestBodyFromJSONTyped(json, false);
}
exports.CandyBlastRequestBodyFromJSON = CandyBlastRequestBodyFromJSON;
function CandyBlastRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'level': json['level'],
    };
}
exports.CandyBlastRequestBodyFromJSONTyped = CandyBlastRequestBodyFromJSONTyped;
function CandyBlastRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'level': value.level,
    };
}
exports.CandyBlastRequestBodyToJSON = CandyBlastRequestBodyToJSON;
